import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {RouterModule} from "@angular/router";
import {CreateOuvrageComponent} from "./create-ouvrage/create-ouvrage.component";
import {FiltersComponent} from "../commons/filters/filters.component";
import {ListOuvrageComponent} from './list-ouvrage/list-ouvrage.component';
import {AuthGuard} from "../services/auth.guard";

const routes = [
  {
    path: 'creation', component: CreateOuvrageComponent, canActivate: [AuthGuard]
  },
  {
    path: 'liste', component: ListOuvrageComponent
  },
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes)
  ],
  declarations: [
  ],
})

export class OuvrageModule {
}
